<template>
  <fieldset class="choice-answer">
    <legend class="sr-only">Elige una respuesta</legend>
    <label v-for="option in options" :key="option.value" :class="{ 'is-selected': selected === option.value }">
      <input type="radio" :name="name" :value="option.value" :checked="selected === option.value" @change="select(option.value)">
      <span class="choice-answer__mark" aria-hidden="true"></span>
      <span>{{ option.text }}</span>
    </label>
  </fieldset>
</template>

<script>
export default {
  name: 'ChoiceExerciseAnswer',
  props: {
    options: { type: Array, default: () => [] },
    value: { type: Object, default: () => ({}) },
    answerField: { type: String, default: 'option' }
  },
  computed: {
    selected() { return String(this.value[this.answerField] || ''); },
    name() { return `exercise-answer-${this._uid}`; }
  },
  methods: {
    select(value) { this.$emit('input', { ...this.value, [this.answerField]: String(value) }); }
  }
};
</script>

<style lang="scss" scoped>
.choice-answer { display: grid; gap: 10px; margin: 0; padding: 0; border: 0; }
.choice-answer label { display: grid; grid-template-columns: 24px 1fr; align-items: center; gap: 12px; min-height: 54px; padding: 10px 14px; border: 1px solid var(--modern-border); border-radius: 13px; background: var(--modern-surface); color: var(--modern-text); cursor: pointer; line-height: 1.4; }
.choice-answer label:hover, .choice-answer label.is-selected { border-color: var(--modern-accent); background: var(--modern-accent-soft); }
.choice-answer input { position: absolute; opacity: 0; pointer-events: none; }
.choice-answer__mark { width: 20px; height: 20px; box-sizing: border-box; border: 2px solid var(--modern-border); border-radius: 50%; background: var(--modern-surface); }
.is-selected .choice-answer__mark { border: 6px solid var(--modern-accent); }
.choice-answer label:focus-within { outline: 3px solid color-mix(in srgb, var(--modern-accent) 35%, transparent); outline-offset: 2px; }
.sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0, 0, 0, 0); }
</style>
